import type { Patient, TabType } from '../components/PatientTable';

/**
 * Durante el tour de onboarding de Pacientes, reemplaza la lista real por un único
 * paciente ficticio — mismo criterio que `buildTourSessions` en Sesiones — para que la
 * tabla siempre tenga algo que mostrar, sin depender de que la psicóloga ya tenga
 * pacientes reales cargados. Solo aplica en la tab "Todos" (contexto en el que corren
 * los pasos del tour); en cualquier otra tab devuelve la lista real sin tocar.
 */
export function buildTourPatients(
  tourStepIndex: number,
  activeTab: TabType,
  realPatients: Patient[],
): Patient[] {
  if (tourStepIndex < 0 || activeTab !== 'all') return realPatients;

  const mockPatient: Patient = {
    id: 'tour-patient',
    name: 'Camila Fernández',
    email: 'camila.fernandez@ejemplo.com',
    service: 'Individual',
    totalSessions: 5,
    patientStatus: 'active',
    paymentStatus: 'paid',
    nextSession: 'Mié 15:00',
    lastSession: '10 sep',
  };

  return [mockPatient];
}
